/* eslint-disable max-lines */
import React, { useState } from 'react';
import { useTranslate } from '@im/react-localization';
import Stack from '@mui/material/Stack';
import { StyledText } from '../../../../components/StyledTypography';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Checkbox from '@mui/material/Checkbox';
import { DeatilsResponse } from '../../hooks/deal-details';
import {
  EndUserSearchResponse,
  getERPType,
  useEndUserSearch,
} from '../../hooks/exceptionDeal';
import DrawerWrapper from 'src/components/Drawer/DrawerWrapper';
import {
  CreateNewEndUserFormData,
  useCreateNewEndUserFormFields,
  useCreateNewEndUserForm,
  CreateNewEndUserFields,
  useCreateNewEndUserFormError,
} from '../../hooks/create-new-end-user-form';
import {
  createNewEndUserRequestCreator,
  extractEndUserServerErrors,
  useAddEndUserAddress,
  useCreateNewEndUser,
  CreateNewEndUserResponse,
} from '../../hooks/end-user-hook';
import { useSearchParams } from 'react-router-dom';
import { CreateNewEndUserForm } from './CreateNewEndUserForm';
import SearchExistingEndUserForm from './SearchExistingEndUserForm';
import useSnackBar from '../../../../hooks/useSnackBar';
import ConfirmationDialog from 'src/components/ConfirmationDialog/ConfirmationDialog';

export default function DealDeatailsPageEditEndUser(
  props: Readonly<{
    countryCode: string;
    details: DeatilsResponse | undefined;
    edResellerId?: string;
    handleClose: () => void;
    isMiamiChecked: boolean;
    setEndUserOptionSelected: React.Dispatch<
      React.SetStateAction<EndUserSearchResponse | null>
    >;
    setIsMiamiChecked: React.Dispatch<React.SetStateAction<false | true>>;
  }>
) {
  const translate = useTranslate();
  const [searchParams, setSearchParams] = useSearchParams();
  const businessType = searchParams.get('businessType');
  const CreateNewEndUserFormFields =
    useCreateNewEndUserFormFields(businessType);
  const [formType, setFormType] = useState<'Find exisitng' | 'Create new'>(
    'Find exisitng'
  );
  const [endUserNumber, setEndUserNumber] = useState<string>('');
  const [cmpEndUserId, setCmpEndUserId] = useState<string>('');
  const [endUserId, setEndUserId] = useState<string>('');
  const [endUserTextValue, setEndUserTextValue] = useState<string>(''); // <-- Track textbox value
  const [prefilledEndUser, setPrefilledEndUser] = useState(() => {
    if (
      props.details?.isaddressmatchrequired === 1 &&
      props.details?.end_user_name
    ) {
      return props.details.end_user_name;
    }
    return '';
  });
  const [topFormError, setTopFormError] = useState<string>('');
  const [newEndUserFormData, setNewEndUserFormData] = useCreateNewEndUserForm();
  const [formError, setFormError] = useCreateNewEndUserFormError();
  const customerNumber = props.edResellerId ?? '';
  const { showSnackBar } = useSnackBar();

  const endUserSearch = useEndUserSearch({
    'IM-CustomerNumber': customerNumber,
    countryCode:
      formType === 'Find exisitng' &&
      props.countryCode === 'US' &&
      props.isMiamiChecked
        ? 'MI'
        : props.countryCode,
  });

  const CreateNewEndUser = useCreateNewEndUser(
    createNewEndUserRequestCreator(
      newEndUserFormData as Record<keyof CreateNewEndUserFields, string>,
      businessType,
      props.details?.businessType === 'Hybrid'
    ),
    customerNumber,
    props.countryCode === 'US' && props.isMiamiChecked
      ? 'MI'
      : props.countryCode
  );
  const AddNewAddress = useAddEndUserAddress(customerNumber, props.countryCode);
  const [hasSaveError, setHasSaveError] = useState(false);
  const [OpenMissingIdDialog, setOpenMissingIdDialog] = useState(false);
  const [missingIdAcknowledge, setmissingIdAcknowledge] = useState(false);

  const onSaveClick = () => {
    if (formType === 'Find exisitng') {
      const [enteredUserName] = String(endUserTextValue ?? '')
        .split('~')
        .map((s) => s.trim());
      const prefilledUserName = (prefilledEndUser ?? '').split('~')[0].trim();
      if (
        props.details?.isaddressmatchrequired === 1 &&
        enteredUserName.toLowerCase() !== prefilledUserName.toLowerCase()
      ) {
        showSnackBar({
          message: 'vendor requires exact end user name match',
          severity: 'error',
        });
        setHasSaveError(true);
        return;
      }
      if (
        businessType === 'Hybrid' &&
        (!endUserNumber || !cmpEndUserId) &&
        !missingIdAcknowledge
      ) {
        setOpenMissingIdDialog(true);
        return;
      }
      searchParams.set('edAcopEndUserId', endUserNumber);
      searchParams.set('cmpAcopEndUserId', cmpEndUserId);
      searchParams.set('endEndUserId', endUserId);
      setSearchParams(searchParams, { replace: true });
      props.handleClose();
      return;
    }

    if (formType === 'Create new') {
      CreateNewEndUser.mutateAsync()
        .then((res) => {
          setTopFormError('');
          endUserSearch
            .mutateAsync({
              endUserName: newEndUserFormData.endUserName,
              erpType: getERPType(
                businessType === 'Subscription',
                props.details?.businessType === 'Hybrid'
              ),
            })
            .then((response) => {
              const { acop, eu } = getAcopEU(response, res);
              setEndUserNumber(acop ? String(acop) : '123');
              setPrefilledEndUser(`${eu.endUserName} ~ ${acop}`);
              setEndUserTextValue(`${eu.endUserName} ~ ${acop}`);
              props.setEndUserOptionSelected(eu);
              setFormType('Find exisitng');
            });
        })
        .catch((error) => {
          if (error?.status === 409) {
            addAddressOnError(error);
          }
          if (error?.response?.error?.field) {
            const formError = extractEndUserServerErrors(
              error?.response?.error?.field
            );
            setFormError(formError);
          } else {
            setTopFormError(error?.response?.error?.message);
          }
        });
    }
  };
  const addAddressOnError = (error: any) => {
    AddNewAddress.mutateAsync({
      address: {
        addressLine1: newEndUserFormData.addressLine1 ?? '',
        addressLine2: newEndUserFormData.addressLine2 ?? '',
        addressLine3: newEndUserFormData.addressLine3 ?? '',
        city: newEndUserFormData.city ?? '',
        countryCode: props.countryCode ?? '',
        erpType: 'I',
        postalCode: newEndUserFormData.postalCode ?? '',
        state: newEndUserFormData.state
          ? newEndUserFormData.state?.toUpperCase()
          : '',
      },
      endUserId: error.response.endUserId,
      endUserNoHold: true,
      overrideRecommendation: true,
    })
      .then((res) => {
        setEndUserNumber(String(res.erpEndUserIdReferences.acopEndUserId));
        setPrefilledEndUser(
          `${newEndUserFormData.endUserName} ~ ${res.erpEndUserIdReferences.acopEndUserId}`
        );
        setFormType('Find exisitng');
      })
      .catch((err) => {
        if (err.status === 409) {
          setTopFormError(err.response.statusMessage);
        } else setTopFormError(err?.response?.error?.message);
      });
  };
  const handleEndUserTextValueChange = (value: string) => {
    setEndUserTextValue(value);
    setHasSaveError(false);
  };
  const handleEndUserOptionSelected = (option: any) => {
    if (businessType === 'Hybrid') {
      setmissingIdAcknowledge(false);
    }
    if (businessType === 'Subscription') {
      setEndUserNumber(option.endUserId);
    } else {
      setEndUserNumber(option.address[0]?.acopEndUserId);
    }
    props.setEndUserOptionSelected(option);
    setCmpEndUserId(option.address[0]?.cmpEndCustomerId);
    setEndUserId(option.endUserId);
  };

  const disableEndUser = customerNumber === '';

  const disableSave = (): boolean => {
    if (hasSaveError) return true;
    if (formType === 'Find exisitng') {
      if (businessType === 'Hybrid' && missingIdAcknowledge) {
        return true;
      }
      if (businessType === 'Hybrid') {
        return disableEndUser;
      }
      return (
        disableEndUser ||
        !(!!endUserNumber?.toString() || !!cmpEndUserId?.toString())
      );
    }
    if (formType === 'Create new') {
      return !Object.keys(CreateNewEndUserFormFields)
        .filter(
          (k) =>
            CreateNewEndUserFormFields[k as keyof CreateNewEndUserFormData]
              ?.required &&
            (CreateNewEndUserFormFields[k as keyof CreateNewEndUserFormData]
              ?.visibleToBusinessType === businessType ||
              CreateNewEndUserFormFields[k as keyof CreateNewEndUserFormData]
                ?.visibleToBusinessType === 'All')
        )
        .every((k) =>
          Boolean(newEndUserFormData?.[k as keyof CreateNewEndUserFormData])
        );
    }
    return true;
  };

  return (
    <DrawerWrapper
      disableSave={disableSave()}
      exception={true}
      handleClose={props.handleClose}
      headerText={translate('VendorDeals.EndUserTitle')}
      loading={
        CreateNewEndUser.isLoading
          ? CreateNewEndUser.isLoading
          : AddNewAddress.isLoading
      }
      onSaveClick={onSaveClick}
    >
      <Stack overflow="auto" p={2}>
        {disableEndUser && (
          <FormGroup>
            <StyledText
              sx={(theme: any) => ({ color: theme.palette.error.main })}
            >
              {translate('VendorDeals.EndUserResellerRequired')}
            </StyledText>
          </FormGroup>
        )}

        <FormGroup>
          <FormControl>
            <Stack direction="row">
              <RadioGroup
                onChange={(event) =>
                  setFormType(event.target.value as typeof formType)
                }
                row
                value={formType}
              >
                <FormControlLabel
                  control={<Radio />}
                  disabled={disableEndUser}
                  label={
                    <StyledText>
                      {translate('VendorDeals.EndUserFindExisting')}
                    </StyledText>
                  }
                  value="Find exisitng"
                />
                <FormControlLabel
                  control={<Radio />}
                  disabled={disableEndUser}
                  label={
                    <StyledText>
                      {translate('VendorDeals.EndUserCreateNew')}
                    </StyledText>
                  }
                  value="Create new"
                />
              </RadioGroup>
              {props.countryCode === 'US' && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.isMiamiChecked}
                      onChange={(e) =>
                        props.setIsMiamiChecked(e.target.checked)
                      }
                    />
                  }
                  label={<StyledText>Miami Only</StyledText>}
                />
              )}
            </Stack>
          </FormControl>
        </FormGroup>
        {formType === 'Find exisitng' && (
          <SearchExistingEndUserForm
            data={endUserSearch.data}
            disableEndUser={disableEndUser}
            endUserTextValue={endUserTextValue}
            handleEndUserOptionSelected={handleEndUserOptionSelected}
            mutate={endUserSearch.mutate}
            prefilledEndUser={prefilledEndUser}
            productType={props.details?.businessType}
            setEndUserTextValue={handleEndUserTextValueChange}
          />
        )}
        {formType === 'Create new' && (
          <CreateNewEndUserForm
            countryCode={props.countryCode}
            details={props.details}
            formData={newEndUserFormData}
            formError={formError}
            setFormData={setNewEndUserFormData}
            setFormError={setFormError}
            topFormError={topFormError}
          />
        )}

        <ConfirmationDialog
          buttons={[
            {
              children: translate('Common.Okay'),
              onClick: () => {
                setmissingIdAcknowledge(true);
                setOpenMissingIdDialog(false);
              },
              sx: {
                textTransform: 'none',
              },
            },
          ]}
          content={translate('VendorDeals.MissingEndUserIDMessage')}
          open={OpenMissingIdDialog}
          title={translate('VendorProgram.Note')}
        />
      </Stack>
    </DrawerWrapper>
  );

  function getAcopEU(
    response: EndUserSearchResponse[],
    res: CreateNewEndUserResponse
  ) {
    const eu = response.filter(
      (val) => val.endUserName === newEndUserFormData.endUserName
    )[0];
    const acop =
      businessType === 'Subscription'
        ? eu.endUserId
        : eu.address.filter((val) => val.addressId === res.addressId)[0]
            .acopEndUserId;
    return { acop, eu };
  }
}
